/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/class-name-casing */
import { BearAsset } from "../AssetConst";
import * as THREE from "three";

export interface coords {
    x: number;
    y: number;
    z: number;
    euler: THREE.Euler;
    width: number;
    height: number;
    scale: number;
}

export interface computedAsset {
    mesh: THREE.Mesh;
    coords: coords;
    originalAsset: BearAsset;
}

export abstract class AssetManager {
    protected _markerWidth: number;
    protected _markerHeight: number;
    private scaleMult = 320;

    constructor(markerWidth: number, markerHeight: number) {
        this._markerHeight = markerHeight;
        this._markerWidth = markerWidth;
    }
    public abstract getComputedAsset(asset: BearAsset): Promise<THREE.Mesh>;

    protected fnGetAssetRealCoords(asset: BearAsset): coords {
        const width = 0.5; // this._markerWidth;
        const height = 0.5; // this._markerHeight;

        const iSide = Math.max(width, height);
        const iMaxX = Math.max(0, height - width) / 2;
        const iMaxY = Math.max(0, width - height) / 2;
        const oCoord = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            scale: 0,
            original: { width: 0, height: 0 },
            bearId: asset.id,
            euler: null,
            z: 0
        };

        oCoord.x = (asset.x + 0.5) * iSide - iMaxX - iSide / 2;
        oCoord.y = (asset.y + 0.5) * iSide - iMaxY - iSide / 2;

        oCoord.width = Math.max(asset.width * iSide, 0.01);
        oCoord.height = Math.max(asset.height * iSide, 0.01);
        oCoord.scale = asset.scale;
        oCoord.original = { width: asset.width, height: asset.height };

        const newRotation = new THREE.Euler(
            -asset.alpha * THREE.Math.DEG2RAD,
            -asset.theta * THREE.Math.DEG2RAD,
            -asset.psi * THREE.Math.DEG2RAD,
            "XYZ"
        );
        oCoord.euler = newRotation;
        let fAlt;
        if (asset.z && asset.z != 0) {
            fAlt = asset.z ? (asset.z * width) / this.scaleMult : 0;
        } else {
            fAlt = asset.zorder * 0.001;
        }
        oCoord.z = fAlt;
        return oCoord;
    }

    /**
     * @param {object} object mesh
     * @param {object} coords asset coords
     * set mesh transform and adds some information to it
     */
    protected fnComputeAssetObject(
        object: THREE.Mesh,
        coords: coords,
        asset: BearAsset
    ): THREE.Mesh {
        const res = object as THREE.Mesh; //{ scale: any; isAsset: boolean; originalAsset: any; bRatio: number; name: string; setRotationFromEuler: Function; position: };
        let minX = 0,
            maxX = 0;
        let firstTime = true;
        object.traverse(function(child) {
            if (child instanceof THREE.Mesh) {
                child.geometry.computeBoundingBox();
                if (firstTime) {
                    minX = child.geometry.boundingBox.min.x;
                    maxX = child.geometry.boundingBox.max.x;
                    firstTime = false;
                } else {
                    minX = Math.min(minX, child.geometry.boundingBox.min.x);
                    maxX = Math.max(maxX, child.geometry.boundingBox.max.x);
                }
            }
        });

        const computedWidth = maxX - minX;
        const targetWidth = Math.max(coords.width, 0.1);
        const scaleFactor = (0.1 * targetWidth) / computedWidth;
        //console.log("scaleFactor=" + scaleFactor);
        const iw = 0; //this._markerWidth;
        const ih = 0; //this._markerHeight;

        res.position.set(
            coords.x - iw / 2 + coords.width / 2,
            -coords.y + ih / 2 - coords.height / 2,
            coords.z
        );
        res.setRotationFromEuler(coords.euler);

        const objScale = coords.scale * scaleFactor;
        /*         console.log(
            "coords.scale=" +
                coords.scale +
                "/scaleFactor=" +
                scaleFactor +
                "=>" +
                objScale
        ); */
        res.scale.set(objScale, objScale, objScale);
        res.isAsset = true;
        res.originalAsset = asset;
        //res.onClick = this.onAssetClick
        res.bRatio = 1;
        res.name = res.originalAsset.name;
        const otherAssetName = asset.name.split("@@")[1];
        if (otherAssetName != undefined) {
            asset.target = otherAssetName;
            asset.action = asset.name.split("@@")[2];
        }

        return res;
    }
}
